module.exports = __webpack_public_path__ + "static/img/3-5.ebbfddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3-5.png
// module id = HOBF
// module chunks = 1